<template>
    <div>
      <section class="signin signup popup-in popup-up">
        <div class="container">
          <div class="row">
            <div class="col-sm-12">
              <div class="single-sign">
                <div class="sign-content popup-in-content">
                  <div class="popup-in-txt">
                    <h2>sign up</h2>

                    <div class="signin-form">
                      <form action="signin.html">
                        <div class="row">

                          <div class="col-sm-12">
                            <div class="form-group">
                              <label for="signin_form">Name</label>
                              <input type="text" class="form-control" id="signin_form" placeholder="watson" v-model="username">
                            </div><!--/.form-group -->
                          </div><!--/.col -->
                        </div><!--/.row -->
                        <!--<div class="form-group">-->
                          <!--<label for="signin_form">Email</label>-->
                          <!--<input type="email" class="form-control" id="signin_form" placeholder="info@abc.com">-->
                        <!--</div>&lt;!&ndash;/.form-group &ndash;&gt;-->
                        <div class="form-group">
                          <label for="signin_form">password</label>
                          <input type="password" class="form-control" id="signin_form" placeholder="Password" v-model="password">
                        </div><!--/.form-group -->

                      </form><!--/form -->
                    </div><!--/.signin-form -->
                    <div class="signin-footer">
                      <button type="button" class="btn signin_btn" data-toggle="modal" data-target=".signin_modal" @click="setSingup">
                        sign up
                      </button>
                      <p>
                        Already a Member ? <a href="signin.html">signin</a>
                      </p>
                    </div><!--/.signin-footer -->
                  </div><!--/.popup-in-txt -->
                </div><!--/.sign-content -->
              </div><!--/.single-sign -->
            </div><!--/.col -->
          </div><!--/.row-->
        </div><!--/.container -->
      </section><!--/.signin -->

      <!-- signin end -->

      <!--footer copyright start -->
      <footer class="footer-copyright">
        <div id="scroll-Top">
          <i class="fa fa-angle-double-up return-to-top" id="scroll-top" data-toggle="tooltip" data-placement="top" title="" data-original-title="Back to Top" aria-hidden="true"></i>
        </div><!--/.scroll-Top-->

      </footer><!--/.hm-footer-copyright-->
      <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                &times;
              </button>
              <h4 class="modal-title" id="myModalLabel">
                提示
              </h4>
            </div>
            <div class="modal-body">
             {{message}}
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-default" data-dismiss="modal">关闭
              </button>
              <button type="button" class="btn btn-primary">
                确定
              </button>
            </div>
          </div><!-- /.modal-content -->
        </div><!-- /.modal -->
      </div>
    </div>
</template>

<script>
import https from './js/https.js'
export default {
  name: 'singin',
  data () {
    return {
      username: '',
      password: '',
      message: ''
    }
  },
  methods: {
    setSingup () {
      https.fetchPost('mocalilie/api/user/register', {
        username: this.username,
        password: this.password
      }).then((res) => {
        console.log(res)
        if (res.data.code=='0') {
          this.message = '注册成功'
        } else {
          this.message = '注册失败'
        }
      })
    }
  },
  created () {
  }
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/Singup.vue